import { EmptyState, Typography, Button } from "@chr/eds-react"
import { Stack } from "@mui/material"
import { useTranslation } from "@chr/online-shared-ui-localizations";
import { useContext } from "react";
import { ConfigContext } from "@chr/navisphereonline-shared-components";


export const GenericErrorPage = () => {
  const translate = useTranslation();
  const appconfig = useContext(ConfigContext) as AppConfig;

  const redirectToSearchPage = () => {
    window.location.assign(`${appconfig?.baseUrl}/search`);
  }

  return (
    <>
      <Stack data-testid="generic-error-page" alignItems="flex-start" paddingLeft={4}>
        <Button
          buttonText={translate('Back')}
          onClick={redirectToSearchPage}
          startIcon="arrow_back"
          variant="tertiary"
          id="go-back-button"
        />
        <Typography variant="display200">{translate('Booking Details')}</Typography>
      </Stack>
      <Stack justifyContent={"center"} padding={4} width="100%" height={"60vh"}
        sx={{
          '.MuiContainer-root': {
            backgroundColor: "#fff",
            width: "100%",
            padding: "50px",
            border: "1px solid #E5E6E7"
          }
        }}
      >
        <EmptyState
          subtitle="Unable to load the booking"
          description="Please reach out to your CHR account manager."
          illustration="trafficCone"
          secondaryAction={{
            buttonText: translate("Back to Search"),
            onClick: () => redirectToSearchPage(),
          }}
        />
        </Stack>
    </>
  );
}
